export const ALLOWED_TYPES = ["mp4", "m4a"];
export const MAX_FILE_GB = 5;
export const MAX_FILE_SIZE_MB = MAX_FILE_GB * 1024;
